// extracted by mini-css-extract-plugin
export default {"mainBody":"index_mainBody_f-eoj","cmt_past":"index_cmt_past_1xTmT clearfix","cmtBox":"index_cmtBox_aHSWV","footer":"index_footer_J7pfV"};